var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../lib/nunjucks/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["escrow_www/templates/components/escrowShield.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\"><path d=\"M8.25 12.9c-.8 0-1.5-.7-1.5-1.55 0-.8.65-1.55 1.5-1.55h3.95V8.65h-4c-1.5 0-2.65 1.2-2.65 2.7s1.2 2.7 2.65 2.7h4V12.9z\" class=\"logo-shield-inner\" clip-rule=\"evenodd\"/><path d=\"M12.15 24h-.2l-.044-.014C11.133 23.743.511 20.41.85 4.15V3.9L2.4 1.7l.25-.05c.2-.05 9.45-1.5 9.45-1.5s9.3 1.45 9.5 1.5l.25.05 1.55 2.2v.25c.2 8.7-2.8 13.65-5.35 16.25-2.75 2.8-5.65 3.6-5.9 3.6M2.4 4.4c-.2 14.3 8.3 17.6 9.75 18.05C13.6 22 22.1 18.75 21.9 4.4l-.95-1.35c-1.05-.3-5.15-1.3-8.8-1.35-3.51.096-7.389 1.024-8.616 1.318L3.4 3.05zm14.3 2H8.3v1.65h8.4zm-8.4 8.35h8.4v1.65H8.3zm8.4-4.15H8.3v1.65h8.4z\" class=\"logo-shield-border\" clip-rule=\"evenodd\"/></svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["escrow_www/templates/components/escrowShield.html"] , dependencies)